import { axios } from '../../../utils/settings';
import { getTokenHeader, getToken } from '../../auth/action';
import {
  compareProductPricesBetweenTwoStatesUrl,
  createOrderUrl,
  deleteOrderUrl,
  editOrderUrl,
  fetchAllOrderUrl,
  fetchOrderUrl,
  getOrderCalculationsUrl,
  orderStatusUpdateUrl,
  paymentRetryUrl,
  retryPaymentUrl,
  statusUpdateAfterPayUrl,
  updateOrderStatusUrl,
  updatePaymentStatusUrl,
} from '../api';

export const createOrder = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${createOrderUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const compareProductPricesBetweenTwoStatesAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${compareProductPricesBetweenTwoStatesUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const editOrderAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${editOrderUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updatePaymentStatusAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${updatePaymentStatusUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getOrderCalculations = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${getOrderCalculationsUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const fetchOrder = async (id) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${fetchOrderUrl()}/${id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const fetchAllOrder = async (companyId) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${fetchAllOrderUrl()}/${companyId}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateOrderStatusAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${updateOrderStatusUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

//delete DP order
export const deleteOrderAction = async (id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .delete(
        `${deleteOrderUrl()}?order_id=${id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// after payment
export const statusUpdateAfterPay = async ({ id, status }) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .put(
        `${statusUpdateAfterPayUrl()}${id}?status=${status}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const retryPaymentAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${retryPaymentUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
